import { GeneralState } from './general-reducer';
import { GeneralActions, GENERAL_ACTION_TYPE, InitialLoad } from './general-type';

export const generalCreators = {
  setGeneralState: <KeyName extends keyof GeneralState>(key: KeyName, value: GeneralState[KeyName])
    : GeneralActions => ({
      type: GENERAL_ACTION_TYPE.SET_STATE,
      payload: { key, value }
    }),
  InitialLoad: (): InitialLoad => ({
    type: GENERAL_ACTION_TYPE.INITIAL_LOAD
  }),
  GetConfig: (configSuccess: (manageEmail: string) => void):
    { configSuccess: (manageEmail: string) => void; type: GENERAL_ACTION_TYPE.GET_CONFIG } => ({
    type: GENERAL_ACTION_TYPE.GET_CONFIG,
    configSuccess
  })
};
